const Track = () => {
  return (
    <svg width='18' height='14' viewBox='0 0 18 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.28571 11.1905H2.52381C1.68223 11.1905 1 10.5082 1 9.66666V2.80952C1 1.96795 1.68223 1.28571 2.52381 1.28571H9.38095C10.2225 1.28571 10.9048 1.96795 10.9048 2.80952V9.66666C10.9048 10.5082 10.2225 11.1905 9.38095 11.1905H8.61905M12.0476 11.1905H11.6667C11.2459 11.1905 10.9048 10.8494 10.9048 10.4286V3.95238C10.9048 3.53159 11.2459 3.19047 11.6667 3.19047H13.5862C13.8176 3.19047 14.0365 3.29569 14.1811 3.47642L16.833 6.7913C16.9411 6.9264 17 7.09425 17 7.26726V10.4286C17 10.8494 16.6589 11.1905 16.2381 11.1905M7.85714 10.8095C7.85714 11.8615 7.00435 12.7143 5.95238 12.7143C4.90041 12.7143 4.04762 11.8615 4.04762 10.8095C4.04762 9.75755 4.90041 8.90476 5.95238 8.90476C7.00435 8.90476 7.85714 9.75755 7.85714 10.8095ZM15.8571 10.8095C15.8571 11.8615 15.0043 12.7143 13.9524 12.7143C12.9004 12.7143 12.0476 11.8615 12.0476 10.8095C12.0476 9.75755 12.9004 8.90476 13.9524 8.90476C15.0043 8.90476 15.8571 9.75755 15.8571 10.8095Z'
        stroke='#6B6B6B'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Track;
